import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';
import { bothRequired } from '../../../../../../../common/forms/custom.validators';
import { toNumber } from '../../../../../../../services/helpers';

@Injectable()
export class DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentServiceForm extends AppForm {

  public publicRoadAccessList: string[] = [
    'Nie dotyczy',
    'Bezpośredni',
    'Pośredni (droga wewnętrzna)',
    'Pośredni (służebność)'
  ];

  constructor() {
    super({
      publicRoadAccess: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),

      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      ),

      publicRoadAccessAdditionalInfo: new FormControl(null, {
        validators: [
          Validators.maxLength(5000)
        ]
      }),

      garageParkingExisting: new FormControl('', { nonNullable: true, validators: [] }),
      garageParkingPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      garageParkingPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      parkingLotExisting: new FormControl('', { nonNullable: true, validators: [] }),
      parkingLotPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      parkingLotPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      otherParkingExisting: new FormControl('', { nonNullable: true, validators: [] }),
      otherParkingPlannedMin: new FormControl('', { nonNullable: true, validators: [] }),
      otherParkingPlannedMax: new FormControl('', { nonNullable: true, validators: [] }),

      parkingAdditionalInfo: new FormControl(null, {
        validators: [
          Validators.maxLength(5000)
        ]
      })
    }, {
      validators: [
        bothRequired(['garageParkingExisting', 'garageParkingPlannedMin', 'garageParkingPlannedMax']),
        bothRequired(['parkingLotExisting', 'parkingLotPlannedMin', 'parkingLotPlannedMax']),
        bothRequired(['otherParkingExisting', 'otherParkingPlannedMin', 'otherParkingPlannedMax'])
      ]
    });
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      ...value,
      parcels: value?.parcels?.filter(v => v.tag === 'parcels2') || []
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return {
      ...value,

      garageParkingExisting: toNumber(value?.garageParkingExisting),
      garageParkingPlannedMin: toNumber(value?.garageParkingPlannedMin),
      garageParkingPlannedMax: toNumber(value?.garageParkingPlannedMax),

      parkingLotExisting: toNumber(value?.parkingLotExisting),
      parkingLotPlannedMin: toNumber(value?.parkingLotPlannedMin),
      parkingLotPlannedMax: toNumber(value?.parkingLotPlannedMax),

      otherParkingExisting: toNumber(value?.otherParkingExisting),
      otherParkingPlannedMin: toNumber(value?.otherParkingPlannedMin),
      otherParkingPlannedMax: toNumber(value?.otherParkingPlannedMax)
    };
  }
}
